import { Cryptocoin as OldCryptoCoin } from "@models";
import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { Logo } from "@modules/+new/payments/shared-payments/entities/logo.model";
import { AssetPrice, AssetPriceAdapter } from "@modules/+new/assets/domain/entities/asset-price.model";
import { Injectable } from "@angular/core";
import { AssetInfo, AssetInfoAdapter } from "@modules/+new/assets/domain/entities/asset-info.model";
import { AssetSettings, AssetSettingsAdapter } from "@modules/+new/assets/domain/entities/asset-settings.model";
import { TradableDetailInterface } from "@models/interfaces/tradable_detail_types";

export interface CryptoCoin {
	readonly androidSupportedVersion?: string; // TODO unused?
	assetInfo: AssetInfo;
	assetPrice: AssetPrice;
	assetSettings: AssetSettings;
	readonly assetGroupName: string;
	readonly assetTypeName?: string; // TODO unused?

	// TODO [begin] Socket (high-volatile) prices fields
	// TODO values (from socket) should be merged dynamically with assetPrice fields?
	readonly avgPrice?: number;
	readonly change1m?: string;
	readonly change1mAmount?: string;
	readonly change1w?: string;
	readonly change1wAmount?: string;
	readonly change1y?: string;
	readonly change1yAmount?: string;
	readonly change24h?: string;
	readonly change24hAmount?: string;
	// TODO [end]

	readonly color: string; // TODO unused?
	readonly event: string; // TODO unused?
	readonly family?: string; // TODO unused? no explicit setter and getter in the old model?
	readonly id: number;
	readonly pid: string;
	readonly iosSupportedVersion?: string; // TODO unused?
	readonly isToken?: boolean; // TODO unused?
	logo: Logo;
	readonly name: string;
	readonly precisionForCoins: number;
	readonly precisionForFiatPrice: number;
	readonly precisionForInternal?: number; // TODO unused?
	readonly precisionForTx: number;
	readonly supportDestinationTag: boolean;
	readonly supportDestinationTagType?: boolean; // TODO unused?
	readonly symbol: string;
	tradableActions: string[];
	tradableDetailFields: string[];
	tradableDetailLabels: TradableDetailInterface[];
	readonly urlCheckAddress: string;
	readonly urlCheckTransaction: string;
}

@Injectable()
export class CryptoCoinAdapter extends BaseAdapter<OldCryptoCoin, CryptoCoin> {
	private assetPriceAdapter = new AssetPriceAdapter();
	private assetInfoAdapter = new AssetInfoAdapter();
	private assetSettingsAdapter = new AssetSettingsAdapter();
	public constructor() {
		super();
	}
	public adapt(item: OldCryptoCoin): CryptoCoin {
		if (!item) {
			return null;
		}

		return {
			assetInfo: this.assetInfoAdapter.adapt(item.getAssetInfo()),
			assetPrice: this.assetPriceAdapter.adapt(item.getAssetPrices()),
			assetSettings: this.assetSettingsAdapter.adapt(item.getAssetSettings()),
			assetGroupName: item.getAssetGroupName(),
			color: item.getColor(),
			event: item.getEvent(),
			id: Number(item.getId()),
			pid: item.getPid(),
			logo: {
				defaultUrl: item.getLogo(),
				darkUrl: item.getLogoDark()
			},
			name: item.getName(),
			precisionForCoins: item.getPrecision(),
			precisionForFiatPrice: item.getPrecisionFiat(),
			precisionForInternal: item.getPrecision(),
			precisionForTx: item.getPrecisionForTx(),
			supportDestinationTag: item.getSupportsDestinationTag(),
			symbol: item.getSymbol(),
			tradableActions: item.getTradableActions(),
			tradableDetailFields: item.getDetailFields(),
			tradableDetailLabels: item.tradableDetailLabels,
			urlCheckAddress: item.urlCheckAddress(),
			urlCheckTransaction: item.urlCheckTransaction()
		};
	}
}
